/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
import "core-js/stable";
import "regenerator-runtime/runtime";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("magnific-popup");
require("./scripts/common");

window.Vue = require("vue");
import store from "./store";
import Slick from "vue-slick";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component("app-header", require("./components/Header.vue"));
Vue.component("app-footer", require("./components/Footer.vue"));
Vue.component("app-page-title", require("./components/PageTitle.vue"));
Vue.component("app-popup-modal", require("./components/PopupModal.vue"));
Vue.component("app-profile-modal", require("./components/ProfileModal.vue"));
Vue.component("app-logout-link", require("./components/LogOutLink.vue"));
Vue.component("our-people", require("./components/OurPeople.vue"));

Vue.component("app-newsletter", require("./components/NewsLetter.vue"));
Vue.component("app-searchresults", require("./components/SearchResults.vue"));
Vue.component(
    "app-footerbanner",
    require("./components/utils/FooterBanner.vue")
);
Vue.component(
    "app-individual-card",
    require("./components/utils/IndividualCard.vue")
);

Vue.component("app-dropdown", require("./components/utils/Dropdown.vue"));
Vue.component(
    "app-immigration-news",
    require("./components/ImmigrationNews.vue")
);

// MODULATTE CORE ADDRESS BOOK
Vue.component("address-book", require("./modulatte-core/address/Index.vue"));
Vue.component(
    "address-book-form",
    require("./modulatte-core/address/Form.vue")
);

// MODULATTE CORE SUBSCRIBER FORM
Vue.component(
    "mod-subscribe-form",
    require("./modulatte-core/subscribers/Form.vue")
);

//add a global mixin
import ModHelpers from "../../mixins/ModHelpers.js";
import { Vue } from "vue-property-decorator";

// Sliders
Vue.component("hero-slider", require("./components/sliders/HeroSlider.vue"));
Vue.component(
    "review-slider",
    require("./components/sliders/ReviewSlider.vue")
);
Vue.component("news-slider", require("./components/sliders/NewsSlider.vue"));

Vue.mixin(ModHelpers);

const app = new Vue({
  el: "#app",
  components: { Slick },
  store,
  data () {
    return {
      isLoaded: false,
      isNewsletterOpen: false,
      member: {},
      isFixed: false,
    };
  },

  mounted () {
    setTimeout(() => {
      this.isLoaded = true;
    }, 500)
  },

  methods: {
    openBio (bio) {
      console.log(bio)
    },

    openNewsletter () {
      this.isNewsletterOpen = true
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/app.js